module.exports = __webpack_public_path__ + "static/media/hands-usd.4d676516.svg";